export const SECTION_TITLE = 'NHỮNG MỐC LỊCH SỬ QUAN TRỌNG'

export const EVENTS = [
    {
        year: '1890',
        title: 'Chào đời',
        desc: 'Nguyễn Sinh Cung — tên khai sinh của Bác — chào đời ngày 19/5/1890 tại làng Kim Liên, Nam Đàn, Nghệ An, trong một gia đình nhà nho nghèo giàu lòng yêu nước.',
    },
    {
        year: '1911',
        title: 'Ra đi tìm đường cứu nước',
        desc: 'Ngày 5/6/1911, từ Cảng Nhà Rồng (Sài Gòn), người thanh niên Nguyễn Tất Thành xuất dương với quyết tâm tìm con đường giải phóng dân tộc khỏi ách thực dân.',
    },
    {
        year: '1919',
        title: 'Bản yêu sách của nhân dân An Nam',
        desc: 'Dưới tên Nguyễn Ái Quốc, Người gửi bản yêu sách 8 điểm đến Hội nghị Versailles, đòi các quyền tự do, dân chủ cơ bản cho nhân dân Đông Dương — lần đầu tiên tiếng nói Việt Nam vang lên trên trường quốc tế.',
    },
    {
        year: '1920',
        title: 'Tìm thấy ánh sáng chủ nghĩa Mác-Lênin',
        desc: 'Đọc Luận cương của Lênin về vấn đề dân tộc và thuộc địa, Nguyễn Ái Quốc xúc động đến rơi nước mắt: "Đây là con đường giải phóng chúng ta!" — và gia nhập Đảng Cộng sản Pháp.',
    },
    {
        year: '1930',
        title: 'Thành lập Đảng Cộng sản Việt Nam',
        desc: 'Ngày 3/2/1930 tại Hương Cảng, Nguyễn Ái Quốc chủ trì hội nghị hợp nhất các tổ chức cộng sản, thành lập Đảng Cộng sản Việt Nam — ngọn đuốc dẫn đường cho cách mạng.',
    },
    {
        year: '1941',
        title: 'Trở về Tổ quốc',
        desc: 'Sau 30 năm bôn ba hải ngoại, Bác về nước qua Pác Bó (Cao Bằng), trực tiếp lãnh đạo phong trào, sáng lập Mặt trận Việt Minh, chuẩn bị tổng khởi nghĩa.',
    },
    {
        year: '1945',
        title: 'Tuyên ngôn Độc lập',
        desc: 'Ngày 2/9/1945, trước hàng triệu đồng bào tại Quảng trường Ba Đình lịch sử, Chủ tịch Hồ Chí Minh đọc Tuyên ngôn Độc lập, khai sinh nước Việt Nam Dân chủ Cộng hòa.',
    },
    {
        year: '1954',
        title: 'Chiến thắng Điện Biên Phủ',
        desc: 'Ngày 7/5/1954, quân và dân ta giành chiến thắng "lừng lẫy năm châu, chấn động địa cầu" tại Điện Biên Phủ dưới sự lãnh đạo của Đảng và Bác Hồ, kết thúc 9 năm kháng chiến trường kỳ.',
    },
    {
        year: '1969',
        title: 'Bác ra đi — Di sản trường tồn',
        desc: 'Ngày 2/9/1969, Chủ tịch Hồ Chí Minh qua đời, để lại Di chúc thiêng liêng và sự nghiệp cách mạng vĩ đại. "Dù có phải đốt cháy cả dãy Trường Sơn, cũng phải giành cho được độc lập."',
        isLast: true,
    },
]
